export default __webpack_public_path__ + "static/media/sunIcon.19811611.svg";